export default __webpack_public_path__ + "static/media/eliipa.65fa7981.jpeg";